import { render, staticRenderFns } from "./EvidentiaryReview.vue?vue&type=template&id=7a7a8a62&scoped=true&"
var script = {}
import style0 from "./EvidentiaryReview.vue?vue&type=style&index=0&id=7a7a8a62&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a7a8a62",
  null
  
)

export default component.exports